import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import {
  ArrowRight,
  Target,
  Eye,
  Award,
  CheckCircle
} from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-4 bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto">
          <div className="text-center max-w-4xl mx-auto">
            <Badge className="bg-[#1C4BB6]/10 text-[#1C4BB6] mb-4">About Us</Badge>
            <h1 className="text-5xl font-bold text-gray-900 mb-6">
              Ozone A-1 Services Private Limited
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              Founded in 2022 in Indore by experienced professionals, we have established ourselves as a reliable provider of integrated facility management and manpower solutions.
            </p>
          </div>
        </div>
      </section>

     {/* Director's Message */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto max-w-5xl">
          <Card className="border-0 shadow-xl">
            <CardContent className="p-12">
              <div className="flex flex-col md:flex-row gap-8 items-start">
                <div className="md:w-1/3">
                  <div className="w-32 h-32 bg-gray-200 rounded-full mx-auto mb-4">
                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQWUjJBF3-HVIQD4wMf392fE8Lz3HaOE__Tg&s" alt="" />
                  </div>
                  <div className="text-center">
                    <h3 className="text-xl font-bold text-gray-900">Mr. Rahul Kumar Nikhil</h3>
                    <p className="text-[#1C4BB6] font-semibold">Director</p>
                  </div>
                </div>
                <div className="md:w-2/3 space-y-4">
                  <h2 className="text-3xl font-bold text-gray-900">Director's Message</h2>
                  <p className="text-gray-600 leading-relaxed italic">
                    "With over a decade of industry experience, our commitment is to deliver reliable, compliant, and performance-driven facility management solutions."
                  </p>
                  <p className="text-gray-600 leading-relaxed">
                    We believe that professional ethics, trained workforce, and structured processes form the foundation of sustainable service delivery. Every project we undertake reflects our dedication to trust, accountability, and long-term partnerships.
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <img
                src="https://images.unsplash.com/photo-1768796372362-05c256e61d8c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxmYWNpbGl0eSUyMG1hbmFnZW1lbnQlMjBjb3Jwb3JhdGV8ZW58MHx8fHwxNzcwOTA5MTg3fDA&ixlib=rb-4.1.0&q=85"
                alt="Company Overview"
                className="rounded-2xl shadow-xl w-full"
              />
            </div>
            <div className="space-y-6">
              <h2 className="text-3xl font-bold text-gray-900">Who We Are</h2>
              <p className="text-gray-600 leading-relaxed">
                Our leadership brings over 10 years of professional industry experience, enabling us to understand client expectations, operational challenges, and compliance requirements across multiple sectors.
              </p>
              <p className="text-gray-600 leading-relaxed">
                We focus on operational excellence, structured manpower deployment, transparent compliance systems, and long-term client relationships.
              </p>
              <div className="grid grid-cols-2 gap-6 pt-6">
                <div className="flex items-center space-x-3">
                  <div className="bg-[#1C4BB6] w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="text-white" size={24} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Operational Excellence</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="bg-[#1C4BB6] w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="text-white" size={24} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Transparent Compliance</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="bg-[#1C4BB6] w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="text-white" size={24} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Structured Deployment</p>
                  </div>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="bg-[#1C4BB6] w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0">
                    <CheckCircle className="text-white" size={24} />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Long-term Partnerships</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

     

      {/* Mission & Vision */}
      <section className="py-20 px-4 bg-white">
        <div className="container mx-auto">
          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
                      {/* Vision */}
           <Card className="border-2 border-[#1C4BB6]/20 hover:border-[#1C4BB6] transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-8">
                <div className="bg-[#1C4BB6] w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Eye className="text-white" size={32} />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Vision</h2>
                <p className="text-gray-700 leading-relaxed text-lg">
                  To become a trusted and preferred integrated facility management and staffing services company in India, known for reliability, compliance excellence, and consistent service quality.
                </p>
              </CardContent>
            </Card>
           
            {/* Mission */}
            <Card className="border-2 border-[#1C4BB6]/20 hover:border-[#1C4BB6] transition-all duration-300 hover:shadow-xl">
              <CardContent className="p-8">
                <div className="bg-[#1C4BB6] w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <Target className="text-white" size={32} />
                </div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Mission</h2>
                <ul className="space-y-4">
                  <li className="flex items-start">
                    <ArrowRight className="text-[#1C4BB6] mr-3 flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">To deliver high-quality facility management and manpower solutions</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-[#1C4BB6] mr-3 flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">To maintain strict statutory compliance and transparency</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-[#1C4BB6] mr-3 flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">To build a skilled, trained, and motivated workforce</span>
                  </li>
                  <li className="flex items-start">
                    <ArrowRight className="text-[#1C4BB6] mr-3 flex-shrink-0 mt-1" size={20} />
                    <span className="text-gray-700">To create long-term value for clients through professionalism and trust</span>
                  </li>
                </ul>
              </CardContent>
            </Card>

 
            
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 px-4 bg-[#1C4BB6] text-white">
        <div className="container mx-auto">
          <div className="text-center mb-16">
            <Badge className="bg-white/20 text-white mb-4 border-0">Our Advantage</Badge>
            <h2 className="text-4xl font-bold mb-6">One-Stop Solution For All Your Needs</h2>
            <p className="text-blue-100 max-w-3xl mx-auto text-lg">
              We eliminate the complexity of dealing with multiple vendors by offering structured, centralized, and accountable service management.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {[
              { title: "Integrated Facility Management", icon: Award },
              { title: "Staffing & Workforce Solutions", icon: Award },
              { title: "Housekeeping & Soft Services", icon: Award },
              { title: "Compliance & Payroll Management", icon: Award },
              { title: "Engineering & Technical Support", icon: Award },
              { title: "Security & Safety Solutions", icon: Award }
            ].map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-all duration-300">
                  <Icon className="text-white mb-4" size={32} />
                  <h3 className="text-xl font-semibold">{item.title}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-50 via-white to-blue-50">
        <div className="container mx-auto text-center max-w-4xl">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Ready to Partner With Us?</h2>
          <p className="text-xl text-gray-600 mb-8">
            Let's discuss how we can support your facility management needs with our professional solutions.
          </p>
          <Link to="/contact">
            <Button className="bg-[#1C4BB6] hover:bg-[#154096] text-white px-12 py-6 text-lg transition-all duration-300 hover:shadow-lg hover:scale-105">
              Get in Touch <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
